<template>
    <div class="channel-menu">
        <div v-for="groupId in Object.keys(menuGroups)" :key="groupId" class="group-wrapper">
            <div
                class="group"
                :class="{
                    collapsed: isGroupCollapsed(groupId),
                    selected: isGroupSelected(groupId),
                }"
                @click="toggleGroup(groupId)"
            >
                <div class="left">
                    <span class="icon">
                        <HomeIcon />
                    </span>
                    <span class="title">{{ $t(`whatsapp_business_api.${groupId}`) }}</span>
                </div>
                <div class="right">
                    <IconButton :on-click="() => toggleGroup(groupId)" class="collapse-button">
                        <a-icon type="caret-down" v-if="!isGroupCollapsed(groupId)" />
                        <a-icon type="caret-up" v-else />
                    </IconButton>
                </div>
            </div>
            <div class="list" :class="{ hidden: !isGroupCollapsed(groupId) }">
                <div :key="item.id" v-for="item in menuGroups[groupId].filter((x) => !x.disabled)">
                    <div class="item" :class="{ selected: value === item.id }" @click="$emit('input', item.id)">
                        {{ $t(`whatsapp_business_api.${item.id}`) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NetgsmChannelMenuTypes from "./NetgsmChannelMenuTypes";
import _ from "lodash";
import HomeIcon from "../../../../../../components/svg/icons/HomeIcon.vue";
import IconButton from "../../../../Settings/components/IconButton.vue";

export default {
    name: "NetgsmChannelMenu",
    components: { IconButton, HomeIcon },
    props: {
        value: {
            type: String,
            default: "detail",
        },
    },
    data() {
        return {
            unCollapsedGroupIds: [],
            menuGroups: _.groupBy(NetgsmChannelMenuTypes, "group"),
        };
    },
    methods: {
        isGroupCollapsed(groupId) {
            return !this.unCollapsedGroupIds.includes(groupId);
        },
        isGroupSelected(groupId) {
            return this.menuGroups[groupId].some((item) => item.id === this.value);
        },
        toggleGroup(groupId) {
            if (this.isGroupCollapsed(groupId)) {
                this.unCollapsedGroupIds.push(groupId);
            } else {
                this.unCollapsedGroupIds = this.unCollapsedGroupIds.filter((id) => id !== groupId);
            }
        },
    },
};
</script>
<style scoped lang="scss">
.channel-menu {
    width: 268px;
    min-width: 268px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-right: 1px solid var(--color-border-default);
    overflow-y: auto;
    background: var(--color-bg-default);
    border-radius: 16px 0 0;
    padding: 5px;
    padding-top: 8px;

    .group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-transform: uppercase;
        user-select: none;
        cursor: pointer;
        padding: 5px;

        &:hover {
            background: var(--color-bg-neutral-low-hover);
        }

        .left {
            display: flex;
            gap: 5px;
        }

        .title {
            text-transform: uppercase;
            font-weight: 700;
        }
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        overflow: hidden;
        max-height: 500px;

        &.hidden {
            max-height: 0;
        }

        .item {
            display: flex;
            align-items: center;
            width: 100%;
            min-height: 36px;
            color: var(--color-text-strong-default);
            font-weight: 500;
            padding: 5px;
            padding-left: 8px;
            margin: 0 8px;
            border-radius: 8px;
            cursor: pointer;
            gap: 5px;

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            &.selected {
                background: var(--color-bg-active);
                border-left: 4px solid var(--color-bg-primary-default);
            }
        }
    }
}
</style>
